import React from 'react';
import PropTypes from 'prop-types';

const AdminCard = ({ 
  title, 
  subtitle, 
  children, 
  footerContent, 
  headerActions,
  className = '',
  bodyClassName = '',
  noPadding = false
}) => {
  return (
    <div className={`admin-card card mb-4 ${className}`}>
      {(title || subtitle || headerActions) && (
        <div className="card-header d-flex justify-content-between align-items-center">
          <div>
            {title && <h5 className="card-title mb-0">{title}</h5>}
            {subtitle && <div className="card-subtitle text-muted small">{subtitle}</div>}
          </div>
          {headerActions && (
            <div className="header-actions">
              {headerActions}
            </div>
          )}
        </div>
      )}
      
      <div className={`card-body ${noPadding ? 'p-0' : ''} ${bodyClassName}`}>
        {children}
      </div>
      
      {footerContent && (
        <div className="card-footer">
          {footerContent}
        </div>
      )}
    </div>
  );
};

AdminCard.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  children: PropTypes.node.isRequired,
  footerContent: PropTypes.node,
  headerActions: PropTypes.node,
  className: PropTypes.string,
  bodyClassName: PropTypes.string,
  noPadding: PropTypes.bool
};

export default AdminCard;
